import React from "react";
import { Controller } from "react-hook-form";
import { Grid } from "@mui/material";
import { FormGroup, Input } from "@cofano/cck";
import { Language } from "imports/Utils";

export default ({ control }) => {
	return (
		<Grid xs={6} item>
			<FormGroup label={Language("TYPE")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.callType"
					control={control}
					render={({ field }) => <Input {...field} />} />
			</FormGroup>

			<FormGroup label={Language("LETTER_OF_PROTEST_SUBJECT")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.subject"
					control={control}
					render={({ field }) => <Input {...field} />} />
			</FormGroup>

			<FormGroup label={Language("PRODUCT")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.productName"
					control={control}
					render={({ field }) => <Input {...field} />} />
			</FormGroup>

			<FormGroup label={Language("LOCATION_DESCRIPTION")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.locationDescription"
					control={control}
					render={({ field }) => <Input {...field} />} />
			</FormGroup>

			<FormGroup label={Language("DATE")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.date"
					control={control}
					render={({ field }) => <Input {...field} />} />
			</FormGroup>

			<FormGroup label={Language("REFERENCE")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.reference"
					control={control}
					render={({ field }) => <Input {...field} />} />
			</FormGroup>
		</Grid>
	);
};

